import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import './Page.css'

const DIRECTION = {
  COL: 'col',
  ROW: 'row'
}

class Page extends React.PureComponent {
  render() {
    const { direction, children, ...props } = this.props
    return (
      <div
        className={`page-container ${direction}`}
        {...props}
      >
        {children}
      </div>
    )
  }
}

Page.propTypes = {
  direction: PropTypes.oneOf([DIRECTION.COL, DIRECTION.ROW]).isRequired
}

class Container extends React.PureComponent {
  render() {
    const { direction, flex, children, style={}, ...props } = this.props
    return (
      <div
        className={`container ${direction}`}
        style={_.extend(
          {},
          style,
          { flex }
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
}

Container.propTypes = {
  direction: PropTypes.oneOf([DIRECTION.COL, DIRECTION.ROW]).isRequired,
  flex: PropTypes.string.isRequired
}

class Element extends React.PureComponent {
  render() {
    const { flex, withBorders, children, style={}, ...props } = this.props
    return (
      <div
        className={`element ${ withBorders ? 'borders' : '' }`}
        style={_.extend(
          {},
          style,
          { flex }
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
}

Element.propTypes = {
  flex: PropTypes.string.isRequired,
  withBorders: PropTypes.bool
}

Page.DIRECTION = DIRECTION
Page.Container = Container
Page.Element = Element

export default Page



// WEBPACK FOOTER //
// ./src/components/elements/Page.js